import { GET_ONE } from 'react-admin';
import utils from '../../shared/utils';

const dataBusinessInvoice = (instance, type, params) => {
  const { extension, field, invoiceId, invoiceType, entityId, query } = params;
  const opt = {
    headers: {
      Accept: 'application/pdf',
    },
    responseType: 'blob',
  };
  switch (type) {
    case GET_ONE:
      switch (field) {
        case 'refundNote':
          opt.url = `/business/fleets/${localStorage.getItem('fleetID')}/invoices/${invoiceId}/refundNote`;
          opt.method = 'GET';
          break;
        case 'creditNote':
          opt.url = `/business/fleets/${localStorage.getItem('fleetID')}/invoices/${invoiceId}/creditNote`;
          opt.method = 'GET';
          break;
        case 'invoice':
          switch (extension) {
            case 'PDF':
              opt.url = `/business/fleets/${localStorage.getItem('fleetID')}/invoices/${invoiceId}/pdf`;
              opt.method = 'GET';
              break;

            case 'CSV':
              opt.url = `/business/fleets/${localStorage.getItem(
                'fleetID'
              )}/entities/${entityId}/businessInvoices/${invoiceId}/${(() => {
                if (invoiceType === 'TRIP') return 'trips';
                if (invoiceType === 'PRODUCT') return 'products';
                throw new Error(`Unsupported invoice type ${invoiceType}`);
              })()}`;
              opt.method = 'GET';
              opt.headers = {
                Accept: 'text/csv',
              };
              opt.params = query;
              break;
            default:
              break;
          }
          break;
        default:
          throw new Error(`Unsupported Data Provider request field ${field}`);
      }
      break;
    default:
      throw new Error(`Unsupported Data Provider request type ${type}`);
  }
  utils.hiddenLoadingScreen();
  return instance(opt);
};

export default dataBusinessInvoice;
